import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getFirm2FirmList = async (body) => {
  try {
    const response = await axiosInterceptor.post(APIs.EXTERNALFIRMREQUESTLIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const firm2FirmExportCsvInitiate = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.EXTERNALFIRMCSVEXPORT,
      { data: body }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const firm2FirmExportCsvFetchProgress = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.EXTERNALFIRMCSVEXPORTPROGRESS,
      { data: { token } },
      { headers: { "content-type": "application/json" } }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const firm2FirmExportCsvDownloadFile = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.EXTERNALFIRMCSVEXPORTDOWNLOAD,
      { data: { token } },
      { responseType: "arraybuffer" },
      { headers: { "content-type": "application/json", Accept: "*/*" } }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
